import React from 'react';
import { connect } from 'react-redux';


import './style.css';
import ReduxComponent from "../ReduxComponent";
import LayoutWrapper from '../../layouts/LayoutWrapper.js';
import { 
	Table,
	Button,
	Modal,
	Icon,
	Form,
	Input,
	Spin,
	Checkbox,
	InputNumber
} from 'antd';
import { 
	changeVacationManagement,
	selectVacationManagement,
	updateVacationManagement,
} from '../../actions/attendance-actions';
import vacationManagementService from '../../services/Attendance/vacation-management-service';
const webConfig = require ('../../config.json');


class VacationManagement extends ReduxComponent
{
	initReload = true;
	moduleName = "attendance";
	childModuleName = "vacationManagement";

	state = {
		currentModalStatus: false,
		currentIndex: false,
		currentData: {},
		basicModalStatus: false,
		basicIndex: false,
		basicData: [],
		basicDataStatus: "unload",
		basicCurrentData: {},
		basicCurrentDataStatus: "unload"
	}

	actions = {
		changeAction: this.props.changeVacationManagement,
		selectAction: this.props.selectVacationManagement,
		updateAction: this.props.updateVacationManagement,

		deleteAction: vacationManagementService.deleteVacationManagement,
		createAction: vacationManagementService.createVacationManagement,
	}

	customComponentWillMount () {
		let dataReloaded = false;
		vacationManagementService.selectBasicVacationManagement({}, res => {
			dataReloaded = true;
			this.setState({
				basicData: res.data,
				basicDataStatus: "loaded"
			})
			setTimeout(() => {
				if (!dataReloaded) {
					this.setState({
						basicDataStatus: "loading"
					});
				}
			}, 100);
		}, err => {
			dataReloaded = true;
			this.setState({basicDataStatus: "error"})
		})
	}

	createData = () => this.setState({
		currentModalStatus: true,
		currentIndex: null,
		currentData: {
			vacation_type_name: "",
			is_enabled: true,
			is_paid: true,
			paid_percent: 0
		},
		isPaid: true
	})

	updateData = (record, index) => this.setState({
		currentModalStatus: true,
		currentIndex: index,
		currentData: record,
		isPaid: record.is_paid
	})

	vacationDetail = (id, index) => this.setState({
		basicModalStatus: true,
		basicCurrentDataStatus: "loading",
		basicCurrentDataIndex: index
	}, () => vacationManagementService.selectBasicVacationManagementDetail({vacation_basicsetting_id : id}, res => this.setState({
			basicCurrentData: res.data,
			basicCurrentDataStatus: "loaded"	
	}), err => this.setState({basicCurrentDataStatus: "error"})))

	basicColumn = [{
			title: '假期类型',
			dataIndex: 'vacation_type_name',
			key: 'vacation_type_name',
			className: 'table-global-head-short'
		}, {
			title: '操作',
			dataIndex: 'actions',
			key: 'actions',
			className: 'table-global-head',
			render: (text, record, index) => {
				return (
					<span>
						<Button icon="edit" size="small"
							className="row-action-btn"
							onClick={this.vacationDetail.bind(this, record.id, index)}>查看</Button>
					</span>
				);
			} 
		}
	];

	basicAnnualColumn = [{
			title: '工作年限(A)年',
			dataIndex: 'rule_comment',
			key: 'rule_comment',
			className: 'table-global-head-short'
		}, {
			title: '年假天数(X)天',
			dataIndex: 'rule_value_comment',
			key: 'rule_value_comment',
			className: 'table-global-head'
		}
	];

	basicSickColumn = [{
			title: '连续工龄期限(A)年',
			dataIndex: 'rule_comment',
			key: 'rule_comment',
			className: 'table-global-head-short'
		}, {
			title: '薪资计发标准',
			dataIndex: 'rule_value_comment',
			key: 'rule_value_comment',
			className: 'table-global-head'
		}
	];

	column = [{
			title: '假期类型',
			dataIndex: 'vacation_type_name',
			key: 'vacation_type_name',
			className: 'table-global-head-short'
		},{
			title: '是否启用',
			dataIndex: 'is_enabled',
			key: 'is_enabled',
			className: 'table-global-head-short',
			render: text => <Checkbox disabled checked={text} />
		}, {
			title: '是否带薪',
			dataIndex: 'is_paid',
			key: 'is_paid',
			className: 'table-global-head-short',
			render: text => <Checkbox disabled checked={text} />
		}, {
			title: '带薪百分比',
			dataIndex: 'paid_percent',
			key: 'paid_percent',
			className: 'table-global-head',
			render: text => text + "%"
		}, {
			title: '操作',
			dataIndex: 'actions',
			key: 'actions',
			className: 'table-global-head',
			render: (text, record, index) => {
				return this.props.access.vocation.u_value && 
					<span>
						<Button icon="edit" size="small"
							className="row-action-btn"
							onClick={this.updateData.bind(this, record, index)}>编辑</Button>
					</span>
				
			} 
		}
	];

	render () {
		return (
			<div className="app-module-item">
				<Modal width="1000px"
					visible={this.state.basicModalStatus}
					title={0 === this.state.basicCurrentDataIndex ? "年假规则" : "病假规则"}
					destroyOnClose={true}
					onCancel={() => this.setState({basicModalStatus: false})}
					onOk={() => this.setState({basicModalStatus: false})} >
					{(() => {
						switch (this.state.basicCurrentDataStatus) {
							case "reload":
							case "loaded":
								return (
									<Table columns={0 === this.state.basicCurrentDataIndex ?
										this.basicAnnualColumn : this.basicSickColumn}
									dataSource={this.state.basicCurrentData.Data}
									rowKey={record => record.id}
									scroll={{x: 800}}
									pagination={false} />)
							case "error":
								return (
									<div style={{textAlign:'center', margin: '100px 0px'}}>
										{webConfig.httpFetchErrorInformation}
									</div>);
							case "loading":
							case "unload":
								return (
									<div style={{textAlign:'center', margin: '100px 0px'}}>
										<Spin size="large" />
									</div>);
							default :
								return null;
						}
					})()}
				</Modal>
				<Modal width="1000px"
					visible={this.state.currentModalStatus}
					title="假期"
					destroyOnClose={true}
					onCancel={this.toggleCurrentModal.bind(this, false)}
					onOk={this.publicSubmit} >
					<div className="app-modal-item">
						{this.state.currentData && 
						<Form onSubmit={this.publicSubmit} className="login-form" layout="inline">
							<div style={{marginBottom:"15px"}}>
								<Form.Item label="假期类型">
									{this.props.form.getFieldDecorator('vacation_type_name', {
										rules: [{ required: true, message: '请输入假期类型' }],
										initialValue: this.state.currentData.vacation_type_name
									})(<Input style={{width:"300px"}} />)}
								</Form.Item>
							</div>
							<div style={{marginBottom:"15px"}}>
								<Form.Item label="是否启用">
									{this.props.form.getFieldDecorator('is_enabled', {
										rules: [],
										valuePropName: 'checked',
										initialValue: this.state.currentData.is_enabled
									})(<Checkbox style={{width:"300px"}}/>)}
								</Form.Item>
							</div>
							<div style={{marginBottom:"15px"}}>
								<Form.Item label="是否带薪">
									{this.props.form.getFieldDecorator('is_paid', {
										rules: [],
										valuePropName: 'checked',
										initialValue: this.state.currentData.is_paid
									})(<Checkbox style={{width:"300px"}}
										onClick={event => this.setState({isPaid: event.target.checked})} />)}
								</Form.Item>
							</div>
							{ this.state.isPaid &&
							<div style={{marginBottom:"15px"}}>
								<Form.Item label="带薪百分比">
									{this.props.form.getFieldDecorator('paid_percent', {
										rules: [{ required: true, message: '请输入带薪百分比' }],
										initialValue: this.state.currentData.paid_percent
									})(<InputNumber min={0} max={100} style={{width:"300px"}} />)}
								</Form.Item>
							</div>}
						</Form>}
					</div>
				</Modal>
				<div>
					{(() => {
						switch (this.state.basicDataStatus) {
							case "reload":
							case "loaded":
								return (
									<Table columns={this.basicColumn}
									dataSource={this.state.basicData.Data}
									rowKey={record => record.id}
									scroll={{x: 800}}
									pagination={false} />)
							case "error":
								return (
									<div style={{textAlign:'center', margin: '100px 0px'}}>
										{webConfig.httpFetchErrorInformation}
									</div>);
							case "loading":
							case "unload":
								return (
									<div style={{textAlign:'center', margin: '100px 0px'}}>
										<Spin size="large" />
									</div>);
							default :
								return null;
						}
					})()}
				</div>
				<div style={{clear:"both", marginBottom: "40px"}}></div>
				<div style={{marginBottom: "20px",height: "60px"}}>
					{this.props.access.vocation.c_value && <div className="colAction" style={{float:"left", margin:"0px 10px 10px 0px"}}>
						<Button type="primary" onClick={this.createData}>
							<Icon type="plus-circle-o" />
							<span>新增</span>
						</Button>
					</div>}
					{this.props.access.vocation.d_value && <div className="colAction" style={{float:"left", margin:"0px 10px 10px 0px"}}>
						<Button type="primary" onClick={this.publicDelete}>
							<Icon type="delete" />
							<span>批量删除</span>
						</Button>
					</div>}
				</div>
				<div>{this.publicTableView()}</div>
			</div>
		)
	}
}

const mapStateToProps = state => {
	return {
		attendance: state.attendance
	}
}

const mapDispatchToProps = {
	changeVacationManagement,
	selectVacationManagement,
	updateVacationManagement,
}


VacationManagement = Form.create()(VacationManagement);

export default LayoutWrapper(connect(mapStateToProps, mapDispatchToProps)(VacationManagement));






// WEBPACK FOOTER //
// ./src/routes/Attendance/VacationManagement.js